import {
  FETCH_STATS_SUCCESS,
  FETCH_CURRENT_STATS_SUCCESS,
  FETCH_ABSENCE_STATS_SUCCESS,
} from 'actions/types'

import { userStats, currentStats, absenceStats } from '../api'

import { dataFailure } from "./general";

const fetchStatsSuccess = (stats) => {
  return {
    type: FETCH_STATS_SUCCESS,
    payload: stats
  }
}

const fetchCurrentStatsSuccess = (stats) => {
  return {
    type: FETCH_CURRENT_STATS_SUCCESS,
    payload: stats
  }
}

export const fetchStats = (values) => {
  return async (dispatch) => {
    try {
      const statsJSONData = await dispatch(userStats(values))
      await dispatch(fetchStatsSuccess(statsJSONData))
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

export const fetchCurrentEntitlementsStats = (values) => {
  return async (dispatch) => {
    try {
      const statsJSONData = await dispatch(currentStats(values))
      await dispatch(fetchCurrentStatsSuccess(statsJSONData))
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const fetchAbsenceStatsSuccess = (stats) => {
  return {
    type: FETCH_ABSENCE_STATS_SUCCESS,
    payload: stats
  }
}

export const fetchAbsenceStats = (values) => {
  return async (dispatch) => {
    try {
      const statsJSONData = await dispatch(absenceStats(values))
      await dispatch(fetchAbsenceStatsSuccess(statsJSONData))
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

